/**
 * Farmer Market UI Copy - Arabic/English
 * Ready to plug into i18n system
 */

export const farmerMarketCopy = {
  ar: {
    ticker: {
      title: "مؤشر أسعار اليوم",
      updated: "آخر تحديث",
      tapHint: "اضغط لعرض التفاصيل",
      loading: "جاري تحميل الأسعار…",
      empty: "لا توجد أسعار متاحة اليوم",
    },
    priceHint: {
      label: "سعر السوق اليوم",
      avg: "متوسط اليوم",
      range: "النطاق المتوقع",
      basedOn: "حسب سوق",
      stateFallback: "متوسط السودان",
    },
    priceWarnings: {
      ok: "سعرك قريب من سعر السوق ✅",
      slightlyHigh: "سعرك أعلى قليلاً من سعر السوق.",
      slightlyLow: "سعرك أقل قليلاً من سعر السوق.",
      unusual: "⚠️ سعر غير معتاد — سيتم مراجعة الإعلان قبل النشر.",
      missingMarket: "لا تتوفر أسعار سوق لهذا المنتج الآن. يمكنك المتابعة.",
    },
    actions: {
      browse: "تصفح",
      viewPrices: "عرض الأسعار",
      contact: "تواصل",
      loginToContact: "سجّل الدخول للتواصل",
      postAd: "أضف إعلان",
    },
    admin: {
      pendingTitle: "إعلانات قيد المراجعة",
      noPending: "لا توجد إعلانات قيد المراجعة",
      filters: {
        all: "الكل",
        highDeviation: "انحراف عالي (>35%)",
        crop: "المحصول",
        state: "الولاية",
        market: "السوق",
        search: "بحث بالعنوان / الهاتف",
      },
      columns: {
        ad: "الإعلان",
        asking: "سعر المعلن",
        marketAvg: "متوسط السوق",
        deviation: "الانحراف",
        location: "الموقع",
        submitted: "تاريخ الإرسال",
        actions: "الإجراءات",
      },
      decisions: {
        approve: "موافقة",
        requestChange: "طلب تعديل",
        reject: "رفض",
      },
      notes: {
        approveNote: "تمت الموافقة على الإعلان.",
        requestNote: "يرجى تعديل السعر ليكون ضمن نطاق السوق.",
        rejectNote: "تم رفض الإعلان بسبب سعر غير منطقي أو معلومات غير كافية.",
      },
      toast: {
        updated: "تم تحديث حالة الإعلان بنجاح ✅",
        failed: "فشل تحديث حالة الإعلان. حاول مرة أخرى.",
      },
    },
  },

  en: {
    ticker: {
      title: "Today's Market",
      updated: "Updated",
      tapHint: "Tap for details",
      loading: "Loading prices…",
      empty: "No prices available today",
    },
    priceHint: {
      label: "Today's Market Price",
      avg: "Today's average",
      range: "Expected range",
      basedOn: "Based on market",
      stateFallback: "Sudan average",
    },
    priceWarnings: {
      ok: "Your price is close to the market ✅",
      slightlyHigh: "Your price is slightly higher than market.",
      slightlyLow: "Your price is slightly lower than market.",
      unusual: "⚠️ Unusual price — your ad will be reviewed before publishing.",
      missingMarket: "No market price data right now. You can continue.",
    },
    actions: {
      browse: "Browse",
      viewPrices: "View prices",
      contact: "Contact",
      loginToContact: "Log in to contact",
      postAd: "Post ad",
    },
    admin: {
      pendingTitle: "Pending Ads Review",
      noPending: "No pending ads to review",
      filters: {
        all: "All",
        highDeviation: "High deviation (>35%)",
        crop: "Crop",
        state: "State",
        market: "Market",
        search: "Search title / phone",
      },
      columns: {
        ad: "Ad",
        asking: "Asking price",
        marketAvg: "Market avg",
        deviation: "Deviation",
        location: "Location",
        submitted: "Submitted",
        actions: "Actions",
      },
      decisions: {
        approve: "Approve",
        requestChange: "Request change",
        reject: "Reject",
      },
      notes: {
        approveNote: "Ad approved.",
        requestNote: "Please update the price to match market range.",
        rejectNote: "Ad rejected due to unrealistic price or insufficient info.",
      },
      toast: {
        updated: "Ad status updated ✅",
        failed: "Failed to update ad. Try again.",
      },
    },
  },
};

// Helper to get translations
export const getFarmerCopy = (lang = 'en') => {
  return farmerMarketCopy[lang] || farmerMarketCopy.en;
};
